<!--교우선택 팝업 -->
<template>
  <div>
    <transition name="modal">
      <div class="modal-mask search-friend-modal" v-if="isModalShow">
        <div class="modal-wrapper">
          <vue-draggable-resizable :x="300" :y="-400" :w="900" :h="750" :z="10" :parent="false" @resizing="onResizing">
            <div class="modal-container" style="width: 100%; height: 100%; max-width: none">
              <div class="modal-header">
                <h4 class="modal-title">교우 조회</h4>
                <md-button class="md-simple md-just-icon md-round modal-default-button" @click="closed">
                  <md-icon>clear</md-icon>
                </md-button>
              </div>

              <div class="modal-body text-center">
                <div class="md-layout">
                  <table class="flex-table">
                    <tr>
                      <th>교우명</th>
                      <td>
                        <input v-focus type="text" v-model="modalQuery.memberHnm" v-on:keyup.enter="modalSearchQuery"/>
                      </td>
                      <th>교우번호</th>
                      <td>
                        <input type="text" v-model="modalQuery.memberNo" maxlength="8" v-on:keyup.enter="modalSearchQuery"/>
                      </td>
                      <th>성별</th>
                      <td>
                        <label>
                          <input type="radio" value="M" v-model="modalQuery.sex" />남
                        </label>
                        <label>
                          <input type="radio" value="F" v-model="modalQuery.sex" />여
                        </label>
                      </td>
                      <th>학위</th>
                      <td>
                        <select v-model="modalQuery.degreeCd">
                          <option value="">- 전체 -</option>
                          <option v-for="item in degreeCdTypeList" :key="item.code" :label="item.codeNm" :value="item.code"></option>
                        </select>
                      </td>
                      <th>학번</th>
                      <td>
                        <input type="text" v-mask="'##########'" v-model="modalQuery.hakbun" v-on:keyup.enter="modalSearchQuery"/>
                      </td>
                    </tr>
                    <tr>
                      <th>대학</th>
                      <td>
                        <div class="inline-flex">
                          <input type="text" disabled v-model="searchedCollegeName" v-on:keyup.enter="searchCollege"/>
                          <button @click=" () => { this.isShowCollegeModal = true; }">
                            <md-icon>search</md-icon>
                          </button>
                        </div>
                      </td>
                      <th>학과</th>
                      <td>
                        <div class="inline-flex">
                          <input type="text" disabled v-model="searchedClassName"/>
                          <button @click=" () => { this.isShowClassModal = true; }">
                            <md-icon>search</md-icon>
                          </button>
                        </div>
                      </td>
                      <th>입학년월</th>
                      <td><input type="text" v-mask="'####-##'" v-model="modalQuery.enterYm" v-on:keyup.enter="modalSearchQuery"/></td>
                      <th>졸업년월</th>
                      <td><input type="text" v-mask="'####-##'" v-model="modalQuery.graduationYm" v-on:keyup.enter="modalSearchQuery"/></td>
                      <th>생년월일</th>
                      <td><input type="text" v-mask="'####-##-##'" v-model="modalQuery.birthday" v-on:keyup.enter="modalSearchQuery"/></td>
                    </tr>
                    <tr>
                      <td colspan="10" class="button-action-td">
                        <md-button class="md-info md-sm" @click="modalSearchQuery">
                          <md-icon>search</md-icon>
                          교우 조회
                        </md-button>
                        <md-button class="md-default md-sm" @click="modalClearQuery">
                          <md-icon>clear</md-icon>
                          초기화
                        </md-button>
                      </td>
                    </tr>
                  </table>
                </div>
                <md-card>
                  <md-card-header md-alignment="space-between">
                    <h4 class="title">
                      <md-icon>list</md-icon>
                      검색 결과
                    </h4>
                  </md-card-header>
                  <md-card-content>
                    <div class="table-header-info">
                      <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
                      <div>
                        <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                          <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                            {{ item }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <grid ref="executivesGrid"
                          :data="gridProps.data"
                          :columns="gridProps.columns"
                          :options="gridProps.options"
                          :theme="gridProps.theme"
                          :rowHeaders="gridProps.rowHeaders"
                          :columnOptions="gridProps.columnOptions"
                          :language="gridProps.lang"
                          @dblclick="onClickModalMember"
                          @response="response"
                    ></grid>


                  </md-card-content>
                </md-card>
              </div>

              <div class="modal-footer">
                <md-button class="md-default md-sm" @click="closed">닫기</md-button
                >
              </div>
            </div>
          </vue-draggable-resizable>
        </div>
      </div>
    </transition>


    <!-- --------------------------- Modal Popup --------------------------------------->
    <div>
      <!--대학선택 팝업 -->
      <college-search-pop-comp :is-show.sync="isShowCollegeModal" @returnResult="callbackCollege"></college-search-pop-comp>

      <!--학과선택 팝업 -->
      <class-search-pop-comp :is-show.sync="isShowClassModal" :m-code-cd.sync="modalQuery.collegeCd" @returnResult="callbackClass"></class-search-pop-comp>

      <!--국가선택 팝업 -->
      <nation-search-pop-comp :is-show.sync="isShowNationalModal" @returnResult="callbackNation"></nation-search-pop-comp>

    </div>
    <!-- --------------------------- Modal Popup --------------------------------------->
  </div>
</template>

<script>
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import kuaaApi from "@/kuaa/kuaa-api";
import axios from "axios";

import Swal from "sweetalert2";

import { CollegeSearchPopComp, ClassSearchPopComp, NationSearchPopComp } from "@/pages"

export default {
  name: "MemberSearchPopComp2",
  props: {
    isShow : {
      type: Boolean,
      default: false
    },
    serchText: {
      type: String
    }
  },
  components: {
    grid: Grid,
    CollegeSearchPopComp,
    ClassSearchPopComp,
    NationSearchPopComp
  },

  created() {
    this.searchDegreeCdTypes();
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    },
    isModalShow: function(){
      return this.isShow;
    }
  },
  data() {
    return {
      degreeCdTypeList: [],
      // 국가선택
      searchedNationalName: "",
      isShowNationalModal: false,

      // 대학 선택 데이터
      searchedCollegeName: "",
      isShowCollegeModal: false,

      // 학과 선택 데이터
      searchedClassName: "",
      isShowClassModal: false,

      modalQuery: {
        memberHnm: this.serchText,
        memberNo: "",
        degreeCd: "",
        registerNo: "",
        sex: "",
        birthday: "",
        nationalCd: "",
        highschool: "",
        collegeCd: "",
        enterYm: "",
        graduationYm: "",
        perPage: 20,
        total: 0
      },
      pagination: {
        perPage: 100,
        page: 1,
        perPageOptions: [20, 50, 100, 300, 500],
        total: 0
      }
    };
  },

  methods: {
    onResizing(l,t,w,h) {
      this.$refs.executivesGrid.invoke('setBodyHeight', h-500)
      this.$refs.executivesGrid.invoke('refreshLayout')
    },
    closed(){
      this.$emit('update:isShow', false);
    },

    modalSearchQuery() {
      this.doSearch();
    },

    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.executivesGrid, event, this.pagination);
    },

    doSearch() {
      this.$refs.executivesGrid.invoke("readData", 1, this.modalQuery);
    },
    
    /**
     * 학위 조회
     */
    searchDegreeCdTypes() {
      kuaaFnc.fncListCmmCodeL('DEGREE_CD',null,res => {
        this.degreeCdTypeList = res.data.data.contents;
      });
    },
    
    /**
     * 교우 검색 모달에서 초기화 버튼이 클릭
     */
    modalClearQuery() {
      this.searchedNationalName = "";
      this.searchedCollegeName = "";
      this.searchedClassName = "";
      this.modalQuery = {
        memberHnm: "",
        memberNo: "",
        degreeCd: "",
        registerNo: "",
        sex: "",
        birthday: "",
        nationalCd: "",
        highschool: "",
        collegeCd: "",
        classCd: "",
        enterYm: "",
        graduationYm: ""
      };
    },

    initGrid() {
      
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_MEMBER_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.executivesGrid;
      this.gridProps['options']['bodyHeight'] = 225;
      this.gridProps['columns'] = [
          {header: '출력여부', name: 'printingGb', align: "center", width: 80, editable: false, sortable: true,
            formatter(value) {
              return '<input disabled style="background-color:blue;" type="checkbox" name="selectedRow" ' + (value.row.printingGb == "Y" ? 'checked>' : '>');
            }
          },
          {header: '교우번호', name: 'memberNo', width:80, align:"center", sortable: true},
          {header: '교우명', name: 'memberHnm', width:70, sortable: true},
          // {header: '교우직위', name: 'memberorgGb', hidden:true},
          {header: '교우직위', name: 'memberorgGbNm', width:80, align:"center", sortable: true},
          {header: '성별', name: 'sex', align:"center", sortable: true},
          {header: '대학', name: 'collegeCd', hidden:true},
          {header: '대학명', name: 'collegeCdNm', width:150, sortable: true},
          {header: '학과', name: 'classCd', hidden:true, sortable: true},
          {header: '학과명', name: 'classCdNm', width:150, sortable: true},
          {header: '학번', name: 'hakbun', width:150, sortable: true},
          {header: '졸업회수', name: 'graduationNo', align:"center", width:80, sortable: true},
          {header: '졸업년도', name: 'graduationYm', align:"center", width:80, sortable: true},
          {header: '입학년도', name: 'enterYm', align:"center", width:80, sortable: true},
          {header: '직장명', name: 'companyNm', align:"center", sortable: true},
          {header: '부서', name: 'partNm', align:"center", sortable: true},
          {header: '직위', name: 'levelNm', align:"center", sortable: true},
          {header: '발송구분', name: 'postplace', align:"center", sortable: true},
          {header: '미발송사유', name: 'nonpostGb', align:"center", sortable: true}
          
        ];
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e, "교우조회");
      }
    },
    /**
     * 모달 교우선택 목록에서 교우를 선택 (교우 변경 기능)
     */
    onClickModalMember(item) {
      if(item.instance.getRow(item.rowKey) != null) {
        this.$emit('returnResult', item.instance.getRow(item.rowKey));
        this.modalClearQuery();
        this.closed();
      }
    },

    /**
     * 국가 검색
     */
    callbackNation(result) {
      this.searchedNationalName = result.codeNm;
      this.modalQuery.nationalCd = result.code;
      this.searchedClassName = "";
    },

    /**
     * 대학 검색
     */
    callbackCollege(result) {
      this.searchedCollegeName = result.codeNm;
      this.modalQuery.collegeCd = result.code;
      this.searchedClassName = "";
    },

    /**
     * 학과 검색
     */
    callbackClass(result) {
      this.searchedClassName = result.codeNm;
      this.modalQuery.collegeCd = result.code;
      //this.searchedCollegeName = result.groupNm;
    }
  }
}
</script>

<style lang="css" scoped>
</style>